<div class="component-container">
    <table-panel header="Artykuły" class="flex flex-grow">
        <pr-new-table
            panel-body
            class="flex flex-grow"
            [dataService]="productService"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [navigationArr]="navigateLinkArr"
            [sortBy]="sortBy"
            [canNavigate]="true"
        ></pr-new-table>
    </table-panel>
</div>
